import { Component, Inject, OnInit, Optional } from '@angular/core';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { Item } from '@app/core/components/listbox/listbox.component';
import { SrCheckListEquipmentsGet, SrChecklistService } from '@app/services/sr-checklist.service';

@Component({
    selector: 'tt-sr-check-list-equipments',
    templateUrl: './sr-check-list-equipments.component.html',
    styleUrls: ['./sr-check-list-equipments.component.css'],
    standalone: false,
})
export class SrCheckListEquipmentsComponent implements OnInit {
    public page?: SrCheckListEquipmentsGet;
    public equipments: Item[] = [];

    constructor(
        private readonly checklist: SrChecklistService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator,
    ) { this.navigator = useNavigatorFor(navigator, this); }

    public async ngOnInit(): Promise<void> {
        const params = { checklistdata_keyno: String(this.navigator?.params['checklistdata_keyno'] ?? ''), srrefundtype_id: String(this.navigator?.params['srrefundtype_id'] ?? '') };
        this.page = await this.checklist.getEquipments(params);
        this.equipments = await this.checklist.getEquipmentList(this.page);
    }
}
